module.exports = __webpack_public_path__ + "img/icon-citrus.78e4c1bc.svg";